import useOfferUrl from 'hooks/Offers/useOfferUrl'
import OfferPageStateContext from 'contexts/OfferPage/offerPageStateContext'
import { useContext } from 'react'
import { useInView } from 'react-intersection-observer'
import styled from 'styled-components'
import { OptimizelyFeatureFlags } from 'constants/featureFlags'
import useFeatureFlag from 'hooks/Experiments/useFeatureFlag'
import ExperiencesPassportSummaryBox from './ExperiencesPassportSummaryBox'
import useExperiencesPassportForOffer from './useExperiencesPassportForOffer'

const ActivationSentinel = styled.div`
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
`

interface Props {
  offer?: App.HotelOffer | App.HotelOfferSummary | App.BedbankOffer | App.BedbankOfferSummary
  filters?: App.OfferListFilters
  variant?: 'offer-page' | 'search-tile'
}

function ExperiencesPassportOfferSummary({ offer, filters, variant = 'offer-page' }: Props) {
  const { offer: offerPageOffer, bedbankOffer, checkInDate, checkOutDate } = useContext(OfferPageStateContext)
  const resolvedOffer = offerPageOffer ?? bedbankOffer ?? offer
  const resolvedFilters = {
    ...filters,
    checkIn: filters?.checkIn ?? checkInDate,
    checkOut: filters?.checkOut ?? checkOutDate,
  }
  const [activationRef, inView] = useInView({
    rootMargin: '300px 0px',
    triggerOnce: true,
  })
  const experiencesPassportEnabled = useFeatureFlag(OptimizelyFeatureFlags.experiencesPassport)
  const { passport: fetchedPassport } = useExperiencesPassportForOffer({
    offer: resolvedOffer,
    filters: resolvedFilters,
    shouldFetch: variant !== 'search-tile' || inView,
  })
  const passport = experiencesPassportEnabled ? fetchedPassport : undefined
  const offerUrl = useOfferUrl(resolvedOffer as App.AnyOffer, {
    filters: resolvedFilters,
    offerLinkIncludesFilters: !!filters || !!resolvedFilters.checkIn || !!resolvedFilters.checkOut,
  })

  if (!passport) {
    return variant === 'search-tile' && experiencesPassportEnabled
      ? <ActivationSentinel ref={activationRef} aria-hidden="true" />
      : null
  }

  return <ExperiencesPassportSummaryBox passport={passport} primaryActionTo={offerUrl} variant={variant} />
}

export default ExperiencesPassportOfferSummary
